import { useCallback, useEffect, useState } from "react"
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'

import { Model } from "../../../models/model"
import { FormNewTask } from "../FormNewTask"
import { BoxTasks } from "./BoxTasks"
import { iniCreateBudget } from "../../../redux/actions/pptos"
import { Templates } from "../../pptos/templates/Templates"
import { CreateListCrm } from "../../general/crear/CreateListCrm"

export const ActivitiesSection = ({ idOpor, infoOpor, listaClasificacionTask, listaOrigen }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [openForm, setOpenForm] = useState(false)
    const [openTemplates, setOpenTemplates] = useState(false)
    const [tasksList, setTasksList] = useState([])

    const handleGetTasks = useCallback(async () => {
        const results = await Model.getAll({
            url: `crm/taskByOpor/${idOpor}`
        })

        setTasksList(results || [])

    }, [idOpor])

    const handleDoneChange = async (e, id) => {
        const { checked } = e.target

        const newTasks = tasksList.map(it => {
            if (it.id === id) {
                return {
                    ...it,
                    done: checked
                }
            }

            return it
        })

        setTasksList(newTasks)

        await Model.update({
            url: `crm/task/updateState/${id}`,
            dataForm: {
                id,
                status: checked
            },
            resultData: true
        })

        await handleGetTasks()

    }

    const handleDeleteTaks = async (idOpor, id) => {

        const newFiltered = tasksList.filter(it => it.id !== id)
        setTasksList(newFiltered)

        await Model.delete({
            url: `crm/task/delete/${idOpor}/${id}`,
            dataForm: {},
            resultData: true
        })

        await handleGetTasks()

    }

    const handleEditTaks = async (idOpor, id) => {
        setOpenForm(true)
    }

    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl);
    const idx = open ? 'simple-popover' : undefined

    const handleCreate = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const createFrom = (from) => {
        if (from === 'cero') {
            createPpto()
        } else {
            setOpenTemplates(true)
        }
    }

    const createPpto = () => {
        const from = 'crm'
        dispatch(iniCreateBudget(from, infoOpor))
        navigate(`/ppto/0`)
    }

    useEffect(() => {
        handleGetTasks()
    }, [handleGetTasks])

    return (
        <div className='p-3'>

            {openTemplates &&
                <Templates
                    open={openTemplates}
                    setOpen={setOpenTemplates}
                    createFrom={createFrom}
                    infoOpor={infoOpor}
                />
            }

            <CreateListCrm
                idx={idx}
                anchorEl={anchorEl}
                open={open}
                handleClose={handleClose}
                createFrom={createFrom}
            />

            <div className={`flex-1 ${infoOpor?.id_ppto ? 'justify-between' : 'justify-start'} items-center`}>

                <button
                    className='btn mb-3 border-gray-200 p-btn-primary min-w-fit'
                    onClick={() => setOpenForm(true)}
                >+ Programar actividad</button>

                {infoOpor?.id_ppto ?
                    <Link to={`/ppto/${infoOpor?.id_ppto}`} target="_blank" className="ms-4 p-link-hitos text-[16px] me-4 mb-2">
                        <i className="bi bi-link-45deg text-[20px]"></i>
                        <span className="ms-1">Presupuesto Nro. #{infoOpor?.nro_ppto}</span>
                    </Link>
                    :
                    <button
                        className='btn mb-3 border-gray-200 p-btn-primary min-w-fit ms-2 flex-auto'
                        onClick={handleCreate}
                    >
                        <span>+ Crear presupuesto</span>
                        <i className="bi bi-caret-down-fill ms-1"></i>
                    </button>
                }
            </div>



            {openForm &&
                <FormNewTask
                    tasksList={tasksList}
                    setTasksList={setTasksList}
                    setOpenForm={setOpenForm}
                    idOpor={idOpor}
                    handleGetTasks={handleGetTasks}
                    listaClasificacionTask={listaClasificacionTask}
                />
            }

            <h2 className="font-bold text-[18px] mt-3">Actividades pendientes</h2>
            {tasksList?.filter(it => it.done === false).length > 0 ?
                <BoxTasks
                    items={tasksList.length > 0 ? tasksList?.filter(it => it.done === false) : []}
                    handleDoneChange={handleDoneChange}
                    handleDeleteTaks={handleDeleteTaks}
                    handleEditTaks={handleEditTaks}
                    idOpor={idOpor}
                />
                :
                <div className='text-[15px]'>
                    <p className='text-center mt-5 font-bold'>
                        Aún no existen actividades
                    </p>
                    <p className='text-center text-gray-500'>
                        Aquí aparecerán actividades programadas.
                    </p>
                </div>
            }

            <h2 className="font-bold text-[18px] mt-5">Historial</h2>
            {tasksList?.filter(it => it.done === true).length > 0 ?
                <BoxTasks
                    items={tasksList.length > 0 ? tasksList?.filter(it => it.done === true) : []}
                    handleDoneChange={handleDoneChange}
                    handleDeleteTaks={handleDeleteTaks}
                    handleEditTaks={handleEditTaks}
                    idOpor={idOpor}
                />
                :
                <div className='text-[15px]'>
                    <p className='text-center mt-5 font-bold'>
                        Aún no existen actividades completadas
                    </p>
                </div>
            }

        </div>
    )
}